export default __webpack_public_path__ + "static/media/te6.072ffe28.png";